// extracted by mini-css-extract-plugin
export default {"root":"styles_root__lx6GP","title":"styles_title__YZ37+","filterRow":"styles_filterRow__9UxiL","note":"styles_note__NjLSU"};